/*
 * Copyright (c) 2019 by Enrico Ansaloni <enrico.ansaloni@gmail.com>
 */

import { EventEmitter } from 'events';
import RestController from './RestController';
import AuthController from './AuthController';
import { io , Socket } from "socket.io-client";

//import {object} from "prop-types";


type ThemeList = {
    [key:string]: any
}

const themeList:ThemeList = {
    default: {
        colors: {
            "primary": "hsl(223, 26%, 21%)",
            "primary-light": "hsl(219, 53%, 29%)",
            "primary-lighter": "hsl(219, 53%, 29%)",
            "primary-disabled": "hsl(225, 13%, 24%)",
            "red": "hsl(5, 100%, 36%)",
            "white": "hsl(210, 17%, 98%)"
        },
        logo: {
            url: "/images/vst-logo-white.png",
            position: "left"
        }
    },
    health3000: {
        colors: {
            "primary": "hsl(207, 100%, 33%)",
            "primary-light": "hsl(207,86%,42%)",
            "primary-lighter": "hsl(207,59%,50%)",
            "primary-disabled": "hsl(206,34%,29%)",
            "red": "hsl(5, 100%, 36%)",
            "white": "hsl(210, 17%, 98%)"
        },
        logo: {
            url: "/images/health3000_logo_trans.png",
            position: "center"
        }
    }
}

type ThemesMap = {
    [key:string]: string
}

const themesMap:ThemesMap = {
    "localhost": "default",
    "my.vital.st": "default",
    "my-test.vital.st": "default",
    "devtest": "default",
    "health3000.vital.st": "health3000"
}

export class AppController extends EventEmitter {
    // locale
    locale:string = "en";
    // event registry
    eventRegistry: any = {}
    // controllers
    rest: RestController = new RestController(this);
    auth: AuthController = new AuthController(this);
    // state
    state: any = {
        isLoading: false,
        isError: false,
        errors: null,
        message: null,
        rooms: [],
        socketIOConnected: false
    };
    themesMap = themesMap;
    themes: ThemeList = themeList;
    currentTheme = "default";
    schemas:Array<string> = [ "user", "group", "device", "registration", "report", "shares", "comment" ];
    eventList:Array<string> = [ "create", "update", "delete"];
    ENDPOINT:string = "http://localhost:20001";
    socket:Socket;
    socketOptions = { path: '/events', autoConnect: false, reconnection: true, reconnectionAttempts: 5, reconnectionDelayMax: 1000, auth: { token: null, userId: null } };
    user:any;

    constructor(locale?:string) {
        super();
        // set locale
        if(locale && locale !== "") {
            this.setLocale(locale);
        }
        // init socket io
        this.user = {};
        this.ENDPOINT = this.calculateEndpoint();
        this.socket = io(this.ENDPOINT, this.socketOptions);
        // connect events
        // Socket.IO
        this.connectSocketEvents();
        // RestController
        this.rest.on("requestPending", () => {
            // console.log(`AppController.tsx: event from RestController: requestPending`);
            this.state.isLoading = true;
            this.emit("restRequestPending");
        });
        this.rest.on("requestSuccessful", () => {
            // console.log(`AppController.tsx: event from RestController: requestSuccessful`);
            this.state.isLoading = false;
            this.state.isError = false;
            this.state.message = this.rest.message;
            this.emit("restRequestSuccessful");
        });
        this.rest.on("requestFailed", () => {
            console.log(`AppController.tsx: event from RestController: requestFailed: ${this.rest.errors}`);
            this.state.isLoading = false;
            this.state.isError = true;
            this.state.errors = this.rest.errors;
            this.state.message = this.rest.message;
            this.emit("restRequestFailed");
        });
        // AuthController
        this.auth.on('authNeededChanged', () => {
            console.log(`AppController.tsx: event from AuthController: authNeededChanged: ${this.auth.isAuthNeeded() ? "YES" : "NO"}`);
            this.emit("authAuthNeededChanged");
        });
        this.auth.on('loggedInChanged', async () => {
            console.log(`AppController.tsx: event from AuthController: loggedInChanged: ${this.auth.isLoggedIn() ? "YES" : "NO"}`);
            await this.handleLoggedInChangedForSocketIO(this.auth);
            this.emit("authLoggedInChanged");
        });
        this.auth.on('authChanged', () => {
            console.log(`AppController.tsx: event from AuthController: authChanged: ${JSON.stringify(this.auth.auth)}`);
            this.emit("authAuthChanged");
        });
        this.auth.on('loginSuccessful', () => {
            console.log(`AppController.tsx: event from AuthController: loginSuccessful`);
            this.emit("authLoginSuccessful");
        });
        this.auth.on('loginFailed', () => {
            console.log(`AppController.tsx: event from AuthController: loginFailed`);
            this.emit("authLoginFailed");
        });
        // load stored state
        this.getStateFromStorage();
        // socket.io connect
        if(this.auth.isLoggedIn()) {
            this.socketOptions.auth.token = this.auth.auth.accessToken;
            this.socketOptions.auth.userId = this.auth.auth.userId;
        }
        this.socket.connect();
        console.log(`AppController.tsx: constructor`);
        //console.log(`AppController.tsx: DUMP STATE: ${JSON.stringify(this.state, null, 2)}`);
    }

    // connect events
    connectSocketEvents = () => {
        const { rooms } = this.state;
        this.socket.on("connect", () => {
            console.log(`AppController.tsx: Socket.IO connected: ${this.socket.id}`);
            for(const schema of this.schemas) {
                this.socket.emit('subscribe', schema, (response:any) => {
                    console.log(`AppController.tsx [socket.io subscribe event]: ${response.message}`);
                    if(response.status === "ok") {
                        if(!rooms.includes(schema)) {
                            rooms.push(schema);
                            this.state.rooms = rooms;
                        }
                    }
                });
            }
            this.state.socketIOConnected = true;
            this.emit("SocketIOConnected");
        });
        this.socket.on("disconnect", () => {
            console.log(`AppController.tsx: [socket.io disconnect event]: Socket disconnected: ${this.socket.id}`);
            this.state.socketIOConnected = false;
            this.emit("SocketIODisconnected");
        });
        this.socket.on('error', (error) => {
            console.log(`AppController.tsx: error connecting socket: ${error.message}`);
        })
        /*this.socket.onAny( (eventName, schema, data) => {
            console.log(`TestSocketIo.tsx: received event: ${eventName} => ${schema} => ${JSON.stringify(data)}`);
            messages.push({
                eventName: eventName,
                schema: schema,
                data: data
            });
            this.setState({
                messages: messages
            })
        })*/
        this.socket.onAny( (eventName, schema, data) => {
            console.log(`AppController.tsx: [socket.io event received]: schema: ${schema} - eventName: ${eventName}`);
            switch(schema) {
                case "user":
                    if(eventName === "create") {
                        this.emit("onUserCreated", data);
                    }
                    break;
                case "report":
                    if(eventName === "update") {
                        this.emit("onReportUpdated", data);
                    } else if(eventName === "create") {
                        this.emit("onReportCreated", data);
                    }
                    break;
                case "comment":
                    if(eventName === "create") {
                        this.emit("onCommentCreated", data);
                    }
                    break;
                case "device":
                    if(eventName === "update") {
                        this.emit("onDeviceUpdated", data);
                    }
                    break;
            }
        })
    }
    // handle events
    handleLoggedInChangedForSocketIO = async (auth:any) => {
        console.log(`AppController.tsx: handleLoggedInChangedForSocketIO: logged in: ${auth.isLoggedIn()}`);
        if (this.socket.connected && auth.isLoggedIn()) {
            const token = auth.auth.accessToken;
            const userId = auth.auth.userId;
            const user = await this.getUser(auth.auth.userId);
            if(user) {
                console.log("AppController.tsx: handleLoggedInChangedForSocketIO: authenticating socket.io...");
                this.socket.emit('auth', token, userId, async (response:any) => {
                    if(response.status === "ok") {
                        await this.socket.disconnect();
                        this.socketOptions.auth.token = token
                        this.socketOptions.auth.userId = userId;
                        this.socket = io("/", this.socketOptions);
                    }
                });
                /*this.socket.emit('auth', user.username, user.password, async (response:any) => {
                    if(response.status === "ok") {
                        await this.socket.disconnect();
                        this.socketOptions.auth.token = token
                        this.socketOptions.auth.userId = userId;
                        this.socket = io("/", this.socketOptions);
                    }
                });*/
            }
        }
    }

    // rest
    getUser = async (userId:string) => {
        const result  = await this.rest.getData("user", userId);
        if(result.status === "ok") {
            this.state.user = result.data[0];
            return result.data[0];
        } else {
            this.state.user = {};
            return null;
        }
    }

    // util
    calculateEndpoint = () => {
        const protocol = window.location.protocol;
        const fqdn = window.location.hostname;
        const port = window.location.port;
        const parts = fqdn.split(/\./);
        let result;
        if(parts.length === 2) {
            // just put sio in front of top level domain
            result = `${protocol}//sio.${fqdn}`;
        } else if(parts.length > 2) {
            const hostname = parts[0];
            parts.shift();
            const dnsdomainname = parts.join('.');
            result = `${protocol}//${hostname}-sio.${dnsdomainname}`;
        } else {
            result = "http://localhost:20001";
        }
        return result;
    }

    // local storage management
    static getValueFromStorage = (key: string) => {
        let data = localStorage.getItem(key);
        let dataObject = null;
        if (data) {
            try {
                dataObject = JSON.parse(data);
            } catch (e) {
                console.log(`AppController.tsx: getValueFromStorage: KEY=${key} - ERROR: ${e}`);
            }
        }
        return dataObject;
    };

    static setValueToStorage = async (key: string, data: any) => {
        try {
            await localStorage.setItem(key, JSON.stringify(data));
            return true;
        } catch (e) {
            console.log(`AppController.tsx: setValueToStorage: KEY=${key} - ERROR: ${e}`);
            return false;
        }
    };

    static clearValueFromStorage = (key: string) => {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (e) {
            console.log(`AppController.tsx: clearValueFromStorage: KEY=${key} - ERROR: ${e}`);
            return false;
        }
    };

    static clearStorage = () => {
        localStorage.clear();
    };

    // locale accessors
    getLocale = () => {
        return this.locale;
    }

    setLocale = (locale:string) => {
        this.locale = locale;
    }

    // local storage state persistence methods
    getStateFromStorage = () => {
        let state = localStorage.getItem("state");
        let stateObject = null;
        let retval: boolean = false;
        if (state) {
            try {
                stateObject = JSON.parse(state);
                if (stateObject) {
                    this.state = stateObject;
                    retval = true;
                }
            } catch (e) {
                console.log(`AppController.tsx: getStateFromStorage: ERROR: ${e}`);
            }
        }
        return retval;
    };

    saveStateToStorage = async () => {
        try {
            await localStorage.setItem("state", JSON.stringify(this.state));
            return true;
        } catch (e) {
            console.log(`AppController.tsx: saveStateToStorage: ERROR: ${e}`);
            return false;
        }
    };

    // event management
    connectEvent = (scope: string, name: string, callback: any) => {
        if (!this.eventRegistry[scope]) this.eventRegistry[scope] = {}
        // this.eventRegistry[scope][name] = this.addListener(name, callback);
        this.addListener(name, callback)
        this.eventRegistry[scope][name] = callback
        console.debug("ADD EVENT LISTENER FOR SCOPE: %s - EVENT NAME: %s - CALLBACK: %o", scope, name, callback);
        // console.log(`AppController.tsx: ADD EVENT LISTENER FOR SCOPE: ${scope} - EVENT NAME: ${name} - CALLBACK: ${this.eventRegistry[scope][name]}`);
    }

    disconnectEvent = (scope: string, name: string) => {
        if (this.eventRegistry[scope] && this.eventRegistry[scope][name]) {
            // this.eventRegistry[scope][name].remove();
            this.removeListener(name, this.eventRegistry[scope][name])
            console.debug("REMOVE EVENT LISTENER FOR SCOPE: %s - EVENT NAME: %s - CALLBACK: %o", scope, name, this.eventRegistry[scope][name]);
            //console.log(`AppController.tsx: REMOVE EVENT LISTENER FOR SCOPE: ${scope} - EVENT NAME: ${name} - CALLBACK: ${this.eventRegistry[scope][name]}`);
        }
    }

    disconnectEventsForScope = (scope: string) => {
        // console.log("AppController.tsx: disconnectEventsForScope: DUMP LISTENERS BEFORE:");
        // console.log(this.listeners);
        if (this.eventRegistry[scope]) {
            const names = Object.keys(this.eventRegistry[scope])
            for (const i in names) {
                const name = names[i]
                this.disconnectEvent(scope, name)
            }
        }
        // console.log("AppController.tsx: disconnectEventsForScope: DUMP LISTENERS AFTER:");
        // console.log(this.listeners);
    }

    // utils
    capitalizeFirstLetter = (input:string) => {
        return input[0].toUpperCase() + input.slice(1);
    }

    getCurrentFQDN = () => {
        return window.location.hostname || "localhost";
    }

    // theme
    applyCurrentTheme = () => {
        const { themes, themesMap} = this;
        const fqdn = this.getCurrentFQDN();
        console.log("AppController.tsx: applyCurrentTheme called:");
        console.log(`AppController.tsx: detected fqdn: ${fqdn}`);
        //const themeList = Object.keys(themes);
        const currentThemeName = themesMap.hasOwnProperty(fqdn) ? themesMap[fqdn] : "default";
        // const currentThemeName = themesMap[fqdn] || "default";
        this.currentTheme = currentThemeName;
        const currentTheme = themes[currentThemeName];
        const colors = currentTheme.colors;
        console.log(`AppController.tsx: applying theme: ${currentThemeName}`);
        // const cssRoot = document.querySelector<HTMLElement>(":root");
        // if(cssRoot) {
            // const computedStyle = getComputedStyle(cssRoot);
            for (const key of Object.keys(colors)) {
                const value = colors[key];
                document.documentElement.style.setProperty(`--${key}`, value);
                // cssRoot.style.setProperty(`--${key}`, value);
            }
        // }
    }

    static arrayBufferToBase64 = (buffer:Buffer) => {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    static typeSafeCatchErrors = (e:unknown) => {
        if(typeof e === "string") {
            return  new Error(e);
        } else if(e instanceof Error) {
            return e;
        } else {
            return new Error(`typeSafeCatchErrors: don't know how to handle error type: ${typeof e}`);
        }
    }

}

export default AppController;